import { render } from "./ArticleList.vue?vue&type=template&id=036415d0&scoped=true"
import script from "./ArticleList.vue?vue&type=script&lang=js"
export * from "./ArticleList.vue?vue&type=script&lang=js"

import "./ArticleList.vue?vue&type=style&index=0&id=036415d0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-036415d0"

export default script